const baseTreeStructure = {
  Base: {
    'Base machine': [
      { 'Height difference': ['h1', 'h2', 'h3'] },
      { 'In-Out Configuration': ['configuration', 'l_r_angle'] },
      { Model: ['sv_family', 'machine_type', 'track'] },
    ],
    'Multi level': [
      'connection_conveyor',
      'ml_pre_treatment',
      'ml_connection',
      'divert_steering_components',
      'power_supply_box_elec_swing_arm_conn_bridge',
      'nbr_electrical_power_supply_swing_arm',
      'connection_bridge_disassembled_transport',
      'ml_drawing',
    ],
  },
  Optimize: {
    Stability: [
      'nbr_windings',
      'max_angle_center',
      'max_angle_50mm_inner',
      {
        Transfer: [
          'transfer_side',
          'ue_transfer_side',
          'le_transfer_side',
          'product_transfer',
          'knife_belt_transfer_position',
          'waterfall_transfer_height',
          'waterfall_transfer_length',
          'krones_transition_preparation',
          'krones_transition_rollerbed_le',
          'krones_transition_rollerbed_ue',
          'rounded_edge_knife_connection',
          'customized_transition',
        ],
      },
      {
        'Upper end': [
          'u2',
          'u2_value',
          'upper_end_double_bend',
          'ue_angular',
          'return_channel',
          'u1_extension',
          'connection_machine_ue',
          'machine_ref_ue',
        ],
      },
      {
        'Lower end': [
          'l2',
          'l2_value',
          'l1_extension',
          'lower_end_double_bend',
          'le_angular',
          'special_le_slope',
          'connection_machine_le',
          'machine_ref_le',
        ],
      },
    ],
    Size: [
      'product_size',
      {
        Guides: [
          'outside_guide_type',
          'outside_guide_height',
          'inside_guide_type',
          'inside_guide_height',
          'guide_plate',
          'b_guide_connector_plate_ue_le',
        ],
      },
      {
        'Offset outside': [
          'offset_outside',
          'offset_le_outside',
          'offset_ue_outside',
        ],
      },
      {
        'Offset inside': [
          'offset_inside',
          'offset_le_inside',
          'offset_ue_inside',
        ],
      },
      {
        'Clearance options': [
          'return_channel_le',
          'special_return',
          'column_top_extension',
        ],
      },
      {
        'Closure Gap': ['closure_gap', 'closure_gap_nbr_profile'],
      },
    ],
    Flow: [
      'load_check',
      'transport_direction',
      {
        track_type: ['slat_type', 'belt_guide', 'friction_type', 'hf_fl_ratio'],
      },
      {
        Speed: ['speed_range', 'centerline_speed'],
      },
      {
        Construction: [
          'column_type',
          'closed_bottom_column',
          'track_build_in',
          'chain_material',
        ],
      },
      {
        Banking: ['banking', 'banking_angle'],
      },
    ],
  },
  Finalise: {
    'Material & Finishing': [
      {
        Material: [
          'material_package',
          'frame_material',
          'support_frame_material',
          'chain_material',
          'belt_guide_rollers_material',
          'shaft_sprockets_bearing',
        ],
      },
      {
        Finishing: ['frame_finishing', 'frame_colour'],
      },
      {
        Support: [
          'support_frame',
          'feet',
          'floor_support_le',
          'floor_support_rc',
        ],
      },
      {
        Guarding: ['underguarding', 'return_channel_guarding'],
      },
      {
        Plate: ['ambaflex_sticker', 'extra_name_plate'],
      },
    ],
    Drive: [
      'drive_table',
      {
        'Drive setting': [
          'gearmotor_type',
          'drive_region',
          'speed_range',
          'centerline_speed',
          'frequency',
          'frequency_inverter',
          'frequency_inverter_interface',
          'customized_frequency_inverter_interface',
        ],
      },
      {
        Voltage: [
          'voltage_movimot',
          'voltage_50_hz',
          'voltage_60_hz',
          'customized_voltage',
          'voltage_delta_87_hz',
          'earthing',
        ],
      },
      {
        Material: ['stainless_steel_drive', 'motor_colour'],
      },
      {
        Position: ['motor_mounting_position', 'motor_mounting_orientation'],
      },
      {
        'Accessories & Options': [
          'gearmotor_hosting_device',
          'gearmotor_food_grade_oil',
          'special_corrosion_protection',
          'mechanical_isolation_class',
          'thermostatic_isolation_class',
          'thermistor',
          'drive_connector',
          'ul_certification',
          'oil_drip_pan',
          'oil_sight_glass',
          'number_sight_glass',
          'safety_cover',
          'drive_for_special_country',
          'drive_country',
        ],
      },
      {
        Brake: ['brake', 'brake_motor', 'brake_voltage'],
      },
      {
        Arm: ['torque_arm', 'torque_arm_for_drive_type'],
      },
    ],
    'Service & Maintenance': [
      { Lubrication: ['lubrication_type', 'lubrication_location'] },
      {
        Access: [
          'extra_service_access',
          'chain_service_distance_under_ue',
          'clear_inspection_panel',
          'chain_service_distance_from_le_horizontal',
        ],
      },
      {
        Alert: [
          'chain_overlength_detection',
          'chain_overlength_detection_outside_drive_shaft',
          'missing_slat_tab_sensor',
          'alert_connection',
          'junction_box_location',
          'junction_box_location_distance_beneath_upper_end',
          'maintenance_alert_system_location',
          'maintenance_alert_system_distance_beneath_upper_end',
          'sensor_brackets_infeed_outfeed',
          'jam_detection_sensor',
        ],
      },
      {
        'Additional options': [
          'nbr_bracing',
          'funnel_in_return_channel',
          'frame_top_column_netting',
          'mounting_brackets_outer_diam',
          'packing_shipping',
          'monitoring_12_month',
          'chemical_anchor_capsules',
        ],
      },
    ],
    Transport: [
      {
        Packaging: ['packaging_foil', 'packaging_support'],
      },
      {
        'Separable frame': [
          'sliced_column_below_le',
          'distance_flanged_plinth_below_le',
          'sliced_column_windings',
          'distance_split_above_le',
          'chop_off_windings',
          'chop_off_le',
          'chop_off_ue_direct_return',
          'chop_off_ue_extended_return',
          'column_flange_top_column',
          'gearmotor_shaft_removed_shipping',
          'side_guides_adjusted_for_transport',
          'outer_guide_mounted_on_site',
        ],
      },
      {
        'Transport dimensions': [
          'transport_orientation',
          'transport_length',
          'transport_width',
          'transport_height',
          'transport_weight',
        ],
      },
      'lifting_eye_top_column',
    ],
    'Manuals & Certifications': [
      {
        Certifiaction: [
          'ce_certification',
          'noise_measurement_report',
          'ce2b_declaration',
          'ce2b_declaration_language',
        ],
      },
      {
        'Machine manual': [
          'english_manual',
          'dutch_manual',
          'chinese_manual',
          'german_manual',
          'italian_manual',
          'french_manual',
          'spanish_manual',
          'japanese_manual',
          'korean_manual',
          'slovene_manual',
          'polish_manual',
          'portuguese_manual',
          'manual_box_60_inch_above_floor',
          'english_manual_purchase_office',
        ],
      },
      {
        'Digital service': [
          'digital_manual_en',
          'digital_manual_du',
          'digital_manual_ch',
          'digital_manual_ge',
          'digital_manual_it',
          'digital_manual_fr',
          'digital_manual_sp',
          'digital_manual_ja',
          'digital_manual_ko',
          'digital_manual_sln',
          'digital_manual_pl',
          'digital_manual_pt',
          'qr_code_1mm',
          'manual_on_usb_stick',
          'digital_spare_part_list_en',
          'sparepart_list_excel',
        ],
      },
    ],
  },
};

const cloneTreeStructure = (structure) => JSON.parse(JSON.stringify(structure));

export const getTreeStructure = (svFamily) => {
  if (String(svFamily || '').toUpperCase() !== 'SV-L') {
    return baseTreeStructure;
  }

  const treeStructure = cloneTreeStructure(baseTreeStructure);

  treeStructure.Base['Base machine'] = [
    'machine_type',
    { 'In-Out Configuration': ['configuration', 'l_r_angle'] },
    { 'Height difference': ['h1', 'h2', 'h3'] },
    'nbr_windings',
  ];

  treeStructure.Optimize.Stability = [
    'slope_angle_center',
    'max_angle_50mm_inner',
    {
      Transfer: [
        'transfer_side',
        'ue_transfer_side',
        'le_transfer_side',
        'product_transfer',
        'knife_belt_transfer_position',
        'waterfall_transfer_height',
        'waterfall_transfer_length',
        'krones_transition_preparation',
        'krones_transition_rollerbed_le',
        'krones_transition_rollerbed_ue',
        'rounded_edge_knife_connection',
        'customized_transition',
      ],
    },
    {
      'Upper end': [
        'u2',
        'u2_value',
        'upper_end_double_bend',
        'ue_angular',
        'return_channel',
        'u1_extension',
        'connection_machine_ue',
        'machine_ref_ue',
      ],
    },
    {
      'Lower end': [
        'l2',
        'l2_value',
        'l1_extension',
        'lower_end_double_bend',
        'le_angular',
        'connection_machine_le',
        'machine_ref_le',
      ],
    },
  ];

  return treeStructure;
};

export default baseTreeStructure;
